import { useState } from "react";
import { NextPage, GetServerSideProps } from "next";
import Head from "next/head";
// Components
import { MobileWeb } from "../../components/templates";
import { SectionSelectTopics, SectionListQuestions } from "../../components/organisms";
// Configs
import { Topic } from "../../configs/datatype";

interface TanyaJawabProps {
  query: any;
}

const TanyaJawab: NextPage<TanyaJawabProps> = (props: TanyaJawabProps) => {
  const { query } = props;

  const [selected, setSelected] = useState<Topic>("Pembelian");

  const { layout } = query;

  const handleSelectedTopic = (value: Topic) => {
    setSelected(value);
  };

  return (
    <MobileWeb>
      {/* SEO */}
      <Head>
        <title>Foodizmart: Tanya Jawab</title>
        <meta name="description" content="Tanya jawab penggunaan aplikasi foodizmart" />
      </Head>

      {/* Content */}
      <section className="py-4 osahan-main-body" style={{ minHeight: layout === "mobile" ? 300 : 700 }}>

        <SectionSelectTopics selectedTopic={selected} doSelectedTopic={handleSelectedTopic} />

        <SectionListQuestions selectedTopic={selected} />

      </section>
    </MobileWeb>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req, query } = context;

  return { props: { query } };
};

export default TanyaJawab;
